import React from "react";
import { useMap } from "react-leaflet";
import * as L from "leaflet";
import "../plugins/Leaflet-Ruler/leaflet-ruler.css";
import "../plugins/Leaflet-Ruler/leaflet-ruler";
import i18n from "i18next";

import variableColors from "../../_App.module.scss";

const { dangerColor, primaryColor } = variableColors;

declare module "leaflet" {
  namespace Control {
    class Ruler extends Control {
      constructor(options?: any);
    }
  }
  function ruler(options?: any): Control.Ruler;
}

const useLeafletRuler: React.FC = () => {
  const leafletMap = useMap();

  React.useEffect(() => {
    const options = {
      position: "bottomleft",
      circleMarker: {
        color: dangerColor,
        radius: 2,
      },
      lineStyle: {
        color: primaryColor,
        dashArray: "1,6",
      },
      lengthUnit: {
        display: "m",
        decimal: 1,
        factor: 1000,
        label: i18n.t("Odległość"),
      },
      angleUnit: {
        display: "&deg;",
        decimal: 2,
        factor: null,
        label: i18n.t("Kąt"),
      },
    };

    if (!leafletMap) return;

    setTimeout(() => {
      //* V1
      // L.control.ruler(options).addTo(leafletMap);

      //* V2
      const rulerControl = new L.Control.Ruler(options);
      rulerControl.addTo(leafletMap);
    }, 250);
  }, [leafletMap]);
  return null;
};

export default useLeafletRuler;
